export default __webpack_public_path__ + "static/media/gift-icon.46b5bbd2.svg";